import styles from './styles.scss';

const bgColorMap = {
  black: styles.black,
  dark: styles.dark,
  white: styles.white,
  light: styles.light,
  grey: styles.grey,
  medium: styles.medium,
};
const fgColorMap = {
  white: styles.white,
  light: styles.light,
};
const bgColors = [bgColorMap.light, bgColorMap.medium, bgColorMap.white, bgColorMap.grey];

export const getBackground = (index, reverse) => {
  if (!reverse) return bgColors[index % 2];
  return bgColors[+!(index % 2)]; // switch 0 and 1
};
export const startsReversed = (background) =>
  background === bgColorMap.medium || background === bgColorMap.grey;
export const getGivenBackground = (color) => bgColorMap[color || 'white'];
export const needsLightForground = (color) =>
  color !== bgColorMap.light && color !== bgColorMap.white;
export const getForeground = (color) => (needsLightForground(color) ? fgColorMap.light : null);

export const hasDarkBackground = (color) => color === bgColorMap.black || color === bgColorMap.dark;
export const hasMediumBackground = (color) =>
  color === bgColorMap.grey || color === bgColorMap.medium;
